// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.showtab {
    background-color: #156614; 
    padding: 5px; 
    color: #ffffff; 
    margin: 10px; 
    border-radius: 10px;
    cursor: pointer;
}

.hidetab {
    padding: 5px; 
    color: #156614; 
    margin: 10px;
    cursor: pointer;
}`, "",{"version":3,"sources":["webpack://./src/components/Webinars.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,YAAY;IACZ,eAAe;AACnB","sourcesContent":[".showtab {\n    background-color: #156614; \n    padding: 5px; \n    color: #ffffff; \n    margin: 10px; \n    border-radius: 10px;\n    cursor: pointer;\n}\n\n.hidetab {\n    padding: 5px; \n    color: #156614; \n    margin: 10px;\n    cursor: pointer;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
